import { useRef, useState } from "react";
import { toast } from "sonner";
import { FileText, Loader2, Upload, X } from "lucide-react";
import { http, imgSrc, formatApiError } from "@/lib/api";
import { Label } from "@/components/ui/label";

export const BrochureField = ({ path, name, onChange }) => {
  const input = useRef(null);
  const [busy, setBusy] = useState(false);
  const upload = async (file) => {
    if (!file) return;
    if (!file.name.toLowerCase().endsWith(".pdf")) {
      toast.error("Please choose a PDF file");
      return;
    }
    setBusy(true);
    const fd = new FormData();
    fd.append("file", file);
    try {
      const { data } = await http.post("/upload", fd);
      onChange({ brochure: data.path, brochure_name: file.name });
      toast.success("Brochure uploaded");
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setBusy(false);
      if (input.current) input.current.value = "";
    }
  };
  return (
    <div className="sm:col-span-2" data-testid="admin-brochure-field">
      <Label className="lab text-gw-ground">Brochure (PDF, optional — visitors can download it)</Label>
      <div className="mt-2 flex flex-wrap items-center gap-3">
        {path ? (
          <a href={imgSrc(path)} target="_blank" rel="noopener noreferrer" data-testid="admin-brochure-link"
            className="inline-flex items-center gap-2 border border-gw-ground/30 px-3 py-2 text-sm hover:bg-gw-tint transition-colors duration-200">
            <FileText size={14} /> {name || "brochure.pdf"}
          </a>
        ) : <span className="text-sm text-gw-ground/60">No brochure yet</span>}
        <button type="button" onClick={() => input.current?.click()} disabled={busy} data-testid="admin-brochure-upload-button"
          className="lab text-[11px] inline-flex items-center gap-2 border border-gw-ground/30 px-3 py-2 hover:bg-gw-tint transition-colors duration-200 disabled:opacity-60">
          {busy ? <Loader2 size={12} className="animate-spin" /> : <Upload size={12} />} {path ? "Replace PDF" : "Upload PDF"}
        </button>
        {path && (
          <button type="button" onClick={() => onChange({ brochure: "", brochure_name: "" })} data-testid="admin-brochure-remove-button"
            className="lab text-[11px] inline-flex items-center gap-2 border border-gw-ground/30 px-3 py-2 text-destructive hover:bg-red-50 transition-colors duration-200">
            <X size={12} /> Remove
          </button>
        )}
      </div>
      <input ref={input} type="file" accept="application/pdf,.pdf" hidden onChange={(e) => upload(e.target.files?.[0])} data-testid="admin-brochure-file-input" />
    </div>
  );
};
